import classNames from 'classnames';
import styles from './index.module.sass';
import { ReactNode } from 'react';

export const ButtonMain = ({
  onClick,
  label,
  px,
  py,
  active = true,
  className,
}: {
  onClick: () => void;
  label: string | ReactNode;
  px?: number;
  py?: number;
  active?: boolean;
  className?: string;
}) => {
  return (
    <a
      className={classNames(styles.root, className, !active && styles.disabled)}
      style={{ paddingLeft: px, paddingRight: px, paddingTop: py, paddingBottom: py }}
      onClick={(e) => {
        e.preventDefault();
        active && onClick();
      }}
    >
      {label}
    </a>
  );
};
